// Angular
import { Injectable } from "@angular/core";

// Third party
import * as _ from 'lodash';
import * as moment from 'moment'

@Injectable()
export class AccountService {

  constructor() {}

  sortByEndAndStart(promos: any[]): any[] {
    return _.orderBy(
      promos,
      [
        (o) => new Date(o.enddate),
        (o) => new Date(o.startdate)
      ],
      ['asc', 'asc']
    );
  }

  countAvailablePromoGiveaways(promos: any[]): number {
    const now = moment.utc();

    return _.sumBy(promos, (promo) => {

      // must have opt-in
      if (!promo?.hasoptin) return 0;

      // nextEntryTime must be < now (button enabled)
      if (!moment.utc(promo?.nextoptin).isBefore(now)) return 0;

      if (promo?.type === 'Promo' && !promo?.isUsed) {
        // PROMO now <= endDate
        return moment.utc(promo?.enddate).isSameOrAfter(now) ? 1 : 0;
      }

      // GIVEAWAY startDate <= now <= endDate
      return (
        moment.utc(promo?.startdate).isSameOrBefore(now) &&
        moment.utc(promo?.enddate).isSameOrAfter(now) &&
        !promo?.isUsed
      ) ? 1 : 0;
    });
  }

}
